<template>
    <div>
        <div id="checkout">
            <!-- Checkout will insert the payment form here -->
        </div>
    </div>
</template>

<script>
import { postRequest } from '@/api/eclub'
export default {
    data() {
        return {
            order_id: this.$route.query.order_id,
            user_id: "",
            amount: "",
            currency: "",
        };
    },
    mounted() {
        this.requestOrderInfo()
    },
    methods: {

        async requestOrderInfo() {
            console.log('haha'+this.order_id)
            const response = await postRequest('getContentOrder', {  order_id: this.order_id})
            let order =response.data.data
            this.handleOrderData(this.order_id,order)
        },
        handleOrderData(order_id, order) {
            let amount = parseFloat(order.usd_price).toFixed(2)
            let line_items = [{
                price_data: {
                    currency: "usd",//美元
                    product_data: {
                        name: order.content_info.title,
                    },
                    unit_amount: amount * 100,
                },
                quantity: 1,
            }]
            this.pay(order_id, line_items);
        },

        pay(order_id, line_items) {
            // Initialize Stripe.js
            const stripe = Stripe(
                "pk_live_51P128qP6BucL4HOzvB46mZ4G6n5nyygpBo3DmJPSEPo5NSdeTsvrFxVO4PQUF3vO6WhWd1nhEgYcrQ63cFZSpMo500NFO4Pe0i"
            );

            // Move fetchClientSecret outside of initialize
            const fetchClientSecret = async () => {
                const response = await fetch(
                    "https://web-backend.reachable-edu.com/Stripe/EclubStoreContentEmbedPay.php",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            order_id: order_id,
                            line_items: line_items,
                        }),
                    }
                );
                let result = await response.json();
                const { clientSecret } = result;
                return clientSecret;
            };

            // Create and mount checkout directly
            stripe.initEmbeddedCheckout({
                fetchClientSecret,
            }).then(checkout => {
                checkout.mount("#checkout");
            });
        },
    },
};
</script>

<style></style>